import * as prototype from "./prototypes";

export const Login = (state = {loading: true, errMess: null, isAuthenticated: false, profile_status: "false" }, action) => {
  switch (action.type) {
    case prototype.LOGIN_LOADING:
      return {...state, loading: true, errMess: null, isAuthenticated: false, profile_status: "false"}
    
    case prototype.LOGIN_FAILED:
      return {...state, loading: false, errMess: action.payload, isAuthenticated: false, profile_status: "false" }

    case prototype.LOGIN_USER:
      return {...state, loading: false, errMess: null, isAuthenticated: true, profile_status: action.payload }
    
    case prototype.LOGOUT_LOADING:
      return { ...state, loading: true, errMess: null, isAuthenticated: true}
    
    case prototype.LOG_OUT:
      return { ...state, loading: false, errMess: null, isAuthenticated: false, profile_status: "false"}

    default:
      return state
  }
}
// signing

export const Sign_up = (state = { isloading: true, errMess: null, message: null}, action) => {

  switch (action.type) {

    case prototype.SIGNUP_LOADING:
      return { ...state, isloading: true, errMess: null, message: null}
    
    case prototype.SIGNUP_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null}
    
    case prototype.SIGNUP_USER:
      return { ...state, isloading: false, errMess: null, message: action.payload}

    default:
      return state
  }
}


// cv

export const generate_cv = (state = { isloading: true, errMess: null, message: null}, action) => {

  switch (action.type) {

    case prototype.CV_LOADING:
      return { ...state, isloading: true, errMess: null, message: null}
    
    case prototype.GENERATING_CV_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null}
    
    case prototype.CV_GENERATED_SUCCESSFULLY:
      return { ...state, isloading: false, errMess: null, message: action.payload}

    default:
      return state
  }
}


export const existing_cv = (state = { isloading: true, errMess: null, message: null}, action) => {

  switch (action.type) {

    case prototype.EXISTING_CV_LOADING:
      return { ...state, isloading: true, errMess: null, message: null}
    
    case prototype.GENERATING_EXISTING_CV_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null}
    
    case prototype.EXISTING_CV_GENERATED_SUCCESSFULLY:
      return { ...state, isloading: false, errMess: null, message: action.payload}

    default:
      return state
  }
}

// cv id 
export const cv_id = (state = {isloading: true, id: null}, action) => {
  switch (action.type) {

    case prototype.CV_ID_LOADING:
      return { ...state, isloading: true, id: null}
    
    case prototype.CV_ID:
      return {...state, isloading: false, id: action.payload};
    
    default:
      return state;
  }
}
// cv ipics
export const cv_pics = (state = {pics: null}, action) => {
  switch (action.type) {

    case prototype.CV_PICS:
      return {...state, pics: action.payload};
    
    default:
      return state;
  }
}

export const UserInfo = (state = {isloading: true, user: null}, action) => {
  switch (action.type) {

    case prototype.LOADING_USER_NAME:
      return {...state, isloading: true, user: null };

    case prototype.USER_NAME_DB:
      return { ...state, isloading: false, user: action.payload }
    
    default:
      return state;
  }
}


export const get_me_my_cv = (state = { isloading: true, errMess: null, message: []}, action) => {

  switch (action.type) {

    case prototype.GETTING_CV_LOADING:
      return { ...state, isloading: true, errMess: null, message: []}
    
    case prototype.GETTING_CV_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: []}
    
    case prototype.GETTING_CV_SUCCESS:
      return { ...state, isloading: false, errMess: null, message: action.payload}

    default:
      return state
  }
}

// employer

export const get_employer_profile = (state = { isloading: true, errMess: null, message: null}, action) => {

  switch (action.type) {

    case prototype.GET_EMPLOYER_PROFILE_LOADING:
      return { ...state, isloading: true, errMess: null, message: null}
    
    case prototype.GET_EMPLOYER_PROFILE_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null}
    
    case prototype.GET_EMPLOYER_PROFILE_SUCCESS:
      return { ...state, isloading: false, errMess: null, message: action.payload}

    default:
      return state;
  }
}

// save link
export const save_link = (state = { isloading: true, message: null}, action) => {

  switch (action.type) {

    case prototype.SAVE_LINK_LOADING:
      return { ...state, isloading: true,  message: null}
    
    case prototype.SAVE_LINK:
      return { ...state, isloading: false,  message: action.payload}
  
    default:
      return state;
  }
}

// public profile reducer
export const get_public_profile = (state = { isloading: true, errMess: null, message: null}, action) => {

  switch (action.type) {

    case prototype.GET_PUBLIC_PROFILE_LOADING:
      return { ...state, isloading: true, errMess: null, message: null}

    case prototype.GET_PUBLIC_PROFILE_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null}

    case prototype.GET_PUBLIC_PROFILE_SUCCESS:
      return { ...state, isloading: false, errMess: null, message: action.payload}

    default:
      return state;
  }
}

export const get_my_profile = (state = { isloading: true, errMess: null, message: null}, action) => {

  switch (action.type) {

    case prototype.GET_PROFILE_LOADING:
      return { ...state, isloading: true, errMess: null, message: null}
    
    case prototype.GET_PROFILE_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null}
    
    case prototype.GET_PROFILE_SUCCESS:
      return { ...state, isloading: false, errMess: null, message: action.payload}

    default:
      return state;
  }
}

export const verify_mail = (state = { isloading: true, errMess: null, message: ""}, action) => {

  switch (action.type) {

    case prototype.V_MAIL_LOADING:
      return { ...state, isloading: true, errMess: null, message: ""}
    
    case prototype.V_MAIL_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: "done"}

    default:
      return state;
  }
}

export const password_reset = (state = { isloading: true, errMess: null, message: null}, action) => {

  switch (action.type) {

    case prototype.R_SET_LOADING:
      return { ...state, isloading: true, errMess: null, message: null}
    
    case prototype.R_SET_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null}
    
    case prototype.R_SET_SUCCESS:
      return { ...state, isloading: false, errMess: null, message: action.payload}

    default:
      return state;
  }
}


export const activities = (state = {isloading: true, activities: null}, action) => {
  switch (action.type) {
    case prototype.ACTIVITIES_LOADING:
      return { ...state, isloading: true, activities: null}
    
    case prototype.ACTIVITIES:
      return { ...state, isloading: false,  activities: action.payload}
    
    default:
      return state;
  }
}

export const skills = (state = {isloading: true, skills: null}, action) => {
  switch (action.type) {

    case prototype.SKILLS_LOADING:
      return { ...state, isloading: true, skills: null}
    
    case prototype.SKILLS:
      return { ...state, isloading: false,  skills: action.payload}
    
    default:
      return state;
  }
}

export const p_skills = (state = {isloading: true, p_skills: null}, action) => {
  switch (action.type) {

    case prototype.PERSONAL_SKILLS_LOADING:
      return { ...state, isloading: true, p_skills: null}
    
    case prototype.PERSONAL_SKILLS:
      return { ...state, isloading: false,  p_skills: action.payload}
    
    default:
      return state;
  }
}

export const jobTitle = (state = {isloading: true, jobtitle: null}, action) => {
  switch (action.type) {

    case prototype.JOBTITLE_LOADING:
      return { ...state, isloading: true, jobtitle: null}
    

    case prototype.JOBTITLE:
      return { ...state, isloading: false,  jobtitle: action.payload}
    
    default:
      return state;
  }
}


export const Professional_summary = (state = {isloading: true, summary: null}, action) => {
  switch (action.type) {

    case prototype.PROFESSIONAL_SUMMMARY_LOADING:
      return { ...state, isloading: true, summary: null}
    

    case prototype.PROFESSIONAL_SUMMMARY:
      return { ...state, isloading: false,  summary: action.payload }
    
    default:
      return state;
  }
}

export const education = (state = {isloading: true, education: null}, action) => {
  switch (action.type) {
    case prototype.EDUCATION_LOADING:
      return { ...state, isloading: true, education: null}
    
    case prototype.EDUCATION:
      return { ...state, isloading: false,  education: action.payload}
    
    default:
      return state;
  }
}

export const voluntary = (state = {isloading: true, voluntary: null}, action) => {
  switch (action.type) {
    case prototype.VOLUNTARY_LOADING:
      return { ...state, isloading: true, voluntary: null}
    
    case prototype.VOLUNTARY:
      return { ...state, isloading: false,  voluntary: action.payload}
    
    default:
      return state;
  }
}

export const award = (state = {isloading: true, award: null}, action) => {
  switch (action.type) {
    case prototype.AWARD_LOADING:
      return { ...state, isloading: true, award: null}
    
    case prototype.AWARD:
      return { ...state, isloading: false,  award: action.payload}
    
    default:
      return state;
  }
}

export const reference = (state = {isloading: true, ref: null}, action) => {
  switch (action.type) {
    case prototype.REFERENCE_LOADING:
      return { ...state, isloading: true, ref: null}
    
    case prototype.REFERENCE:
      return { ...state, isloading: false,  ref: action.payload}
    
    default:
      return state;
  }
}

export const language = (state = {isloading: true, lang: null}, action) => {
  switch (action.type) {
    case prototype.LANGUAGE_LOADING:
      return { ...state, isloading: true, lang: null}
    
    case prototype.LANGUAGE:
      return { ...state, isloading: false, lang: action.payload}
    
    default:
      return state;
  }
}

export const lang = (state = {isloading: true, lang: null}, action) => {
  switch (action.type) {
    case prototype.LANG_LOADING:
      return { ...state, isloading: true, lang: null}
    
    case prototype.LANG:
      return { ...state, isloading: false, lang: action.payload}
    
    default:
      return state;
  }
}


export const individual_experience = (state = {isloading: true, errMess: null, exp: null}, action) => {
  switch (action.type) {
    case prototype.INDIVIDUAL_EXPERIENCE_LOADING:
      return { ...state, isloading: true, errMess: null, exp: null}

    case prototype.INDIVIDUAL_EXPERIENCE_ERROR:
      return { ...state, isloading: false, errMess: action.payload, exp: null }

    case prototype.INDIVIDUAL_EXPERIENCE:
      return { ...state, isloading: false, errMess: null, exp: action.payload}
    
    default:
      return state;
  }
}


export const translate_lang = (state = {isloading: false, selected: "en"}, action) => {
  switch (action.type) {
    case prototype.LANGUAGE_TRANSLATION_LOADING:
      return { ...state, isloading: false, selected: "en"}
    
    case prototype.LANGUAGE_TRANSLATION:
      return { ...state, isloading: false, selected: action.payload}
    
    default:
      return state;
  }
}


export const persomal_information = (state = {isloading: true, errMess: null, message: null}, action) => {
  switch (action.type) {
    case prototype.PERSONAL_INFO_LOADING:
      return { ...state, isloading: true, errMess: null, message: null}

    case prototype.PERSONAL_INFO_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null }

    case prototype.PERSONAL_INFO:
      return { ...state, isloading: false, errMess: null, message: action.payload}
    
    default:
      return state;
  }
}

export const cert = (state = {isloading: true, cert: null}, action) => {
  switch (action.type) {
    case prototype.CERT_LOADING:
      return { ...state, isloading: true, cert: null}
    
    case prototype.CERT:
      return { ...state, isloading: false,  cert: action.payload}
    
    default:
      return state;
  }
}

export const resumeStepChange = (state = 0,  action) => {
  switch (action.type) {
    case prototype.RESUME_STEP_ADD:
      return state + 1

    case prototype.RESUME_STEP_SUB:
      return state - 1

    case prototype.RESUME_STEP_JUMP:
      return state = action.payload

    default:
      return state
  }
}

export const langType = (state = {isloading: true, type: ""}, action) => {
  switch (action.type) {
    case prototype.LANG_TYPE:
      return { ...state, isloading: true, type: ""}
    
    case prototype.LANG_TYPE_S:
      return { ...state, isloading: false,  type: action.payload}
    
    default:
      return state;
  }
}


export const spanish = (state = {isloading: true, spanish: null}, action) => {
  switch (action.type) {
    case prototype.SPANISH_LOADING:
      return { ...state, isloading: true, spanish: null}
    
    case prototype.SPANISH:
      return { ...state, isloading: false,  spanish: action.payload}
    
    default:
      return state;
  }
}


export const employer_about = (state = {isloading: false, errMess: null, message: null}, action) => {
  switch (action.type) {
    case prototype.ABOUT_LOADING:
      return { ...state, isloading: false, errMess: null, message: null}
      
    case prototype.ABOUT_FAILED:
      return { ...state, isloading: false, errMess: action.payload, message: null }
  
    case prototype.ABOUT:
      return { ...state, isloading: false, errMess: null, message: action.payload}
    
    default:
      return state;
  }
}


export const last_resume = (state = {isloading: true, message: null}, action) => {
  switch (action.type) {
    case prototype.LAST_RESUME:
      return { ...state, isloading: false, message: null}
    
    case prototype.LAST_RESUME_LOADING:
      return { ...state, isloading: true, message: null}


    default:
      return state;
  }
}

export const secret = (state = {isloading: true, secret: null}, action) => {
  switch (action.type) {
    case prototype.SECRET_LOADING:
      return { ...state, isloading: true, secret: null}
    
    case prototype.SECRET:
      return { ...state, isloading: false, secret: action.payload}

    default:
      return state;
  }
}



